<template>
    <v-row justify="center">
        <!-- Section growth tasks dialog -->
        <v-dialog v-model="dialog" scrollable>
            <template>
                <v-card
                    :loading="
                        $apollo.queries.greenhouseDepartmentSection.loading
                            ? 'white'
                            : null
                    "
                    tile
                    height="90vh"
                    class="pb-0"
                >
                    <v-card-title class="primary white--text">
                        <strong class="ml-5">{{
                            greenhouseDepartmentSection
                                ? greenhouseDepartmentSection.name
                                : ""
                        }}</strong>
                        <v-spacer></v-spacer>
                        <v-text-field
                            dense
                            v-model="search"
                            append-outer-icon="search"
                            label="Search"
                            clearable
                            hide-details
                            dark
                        ></v-text-field>
                        <v-spacer />
                        <v-btn icon class="mr-5" dark @click="close">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-card-title>

                    <v-card-text min-height="600px">
                        <v-row dense class="mt-2">
                            <!-- planed tasks -->
                            <v-col cols="12" md="4">
                                <v-card outlined class="grey lighten-4">
                                    <v-card-title
                                        class="grey white--text"
                                        primary-title
                                    >
                                        Planned
                                        <v-spacer />
                                        <v-icon dark>eco</v-icon>
                                        {{ numPlantsInPlannedTasks }}
                                    </v-card-title>
                                    <div
                                        v-if="plannedTasks.length === 0"
                                        class="text-center my-5 grey--text"
                                    >
                                        - no task -
                                    </div>

                                    <!-- task card -->
                                    <v-card-text v-else>
                                        <GrowthTaskCard
                                            v-for="task in plannedTasks"
                                            :key="task.id"
                                            :task.sync="task"
                                            v-on:taskSplited="onTaskSplited"
                                            v-on:taskLocked="onTaskLocked"
                                            v-on:taskUnlocked="onTaskUnlocked"
                                            v-on:taskSupplierUpdated="
                                                onTaskSupplierUpdated
                                            "
                                            v-on:taskDeleted="onTaskDeleted"
                                            v-on:growthTaskPhasesUpdated="
                                                growthTaskPhasesUpdated
                                            "
                                            v-on:growthTaskPhaseConfirmed="
                                                growthTaskPhaseConfirmed
                                            "
                                            v-on:growthTaskInventoryUpdated="
                                                growthTaskInventoryUpdated
                                            "
                                        ></GrowthTaskCard>
                                    </v-card-text>
                                </v-card>
                            </v-col>

                            <!-- Growing tasks -->
                            <v-col cols="12" md="4">
                                <v-card outlined class="grey lighten-4">
                                    <v-card-title
                                        class="success white--text"
                                        primary-title
                                    >
                                        Growing
                                        <v-spacer />
                                        <v-icon dark>eco</v-icon>
                                        {{ numPlantsInGrowingTasks }}
                                    </v-card-title>

                                    <div
                                        v-if="growingTasks.length === 0"
                                        class="text-center my-5 grey--text"
                                    >
                                        - no task -
                                    </div>

                                    <!-- task card -->
                                    <v-card-text v-else>
                                        <GrowthTaskCard
                                            v-for="task in growingTasks"
                                            :key="task.id"
                                            :task.sync="task"
                                            v-on:taskSplited="onTaskSplited"
                                            v-on:taskLocked="onTaskLocked"
                                            v-on:taskUnlocked="onTaskUnlocked"
                                            v-on:taskSupplierUpdated="
                                                onTaskSupplierUpdated
                                            "
                                            v-on:taskDeleted="onTaskDeleted"
                                            v-on:growthTaskPhasesUpdated="
                                                growthTaskPhasesUpdated
                                            "
                                            v-on:growthTaskPhaseConfirmed="
                                                growthTaskPhaseConfirmed
                                            "
                                            v-on:growthTaskInventoryUpdated="
                                                growthTaskInventoryUpdated
                                            "
                                        ></GrowthTaskCard>
                                    </v-card-text>
                                </v-card>
                            </v-col>

                            <!-- saling tasks -->
                            <v-col cols="12" md="4">
                                <v-card outlined class="grey lighten-4">
                                    <v-card-title
                                        class="warning white--text"
                                        primary-title
                                    >
                                        Sales
                                        <v-spacer />
                                        <v-icon dark>eco</v-icon>
                                        {{ numPlantsInSalingTasks }}
                                    </v-card-title>

                                    <div
                                        v-if="salesTasks.length === 0"
                                        class="text-center my-5 grey--text"
                                    >
                                        - no task -
                                    </div>

                                    <!-- task card -->
                                    <v-card-text v-else>
                                        <GrowthTaskCard
                                            v-for="task in salesTasks"
                                            :key="task.id"
                                            :task.sync="task"
                                            v-on:taskSplited="onTaskSplited"
                                            v-on:taskLocked="onTaskLocked"
                                            v-on:taskUnlocked="onTaskUnlocked"
                                            v-on:taskSupplierUpdated="
                                                onTaskSupplierUpdated
                                            "
                                            v-on:taskDeleted="onTaskDeleted"
                                            v-on:growthTaskPhasesUpdated="
                                                growthTaskPhasesUpdated
                                            "
                                            v-on:growthTaskPhaseConfirmed="
                                                growthTaskPhaseConfirmed
                                            "
                                            v-on:growthTaskInventoryUpdated="
                                                growthTaskInventoryUpdated
                                            "
                                        ></GrowthTaskCard>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions class="ma-0 pa-0">
                        <v-progress-linear
                            height="30"
                            :value="
                                greenhouseDepartmentSection
                                    ? greenhouseDepartmentSection.usedRate * 100
                                    : 0
                            "
                            color="light-green accent-4"
                            class="green--text text--darken-4"
                            background-color="grey lighten-2"
                        >
                            <v-spacer />
                            <strong
                                >Occupied =
                                {{
                                    greenhouseDepartmentSection
                                        ? greenhouseDepartmentSection.usedSpaceM2
                                        : ""
                                }}&#13217;, Available =
                                {{
                                    greenhouseDepartmentSection
                                        ? greenhouseDepartmentSection.spaceM2 -
                                          greenhouseDepartmentSection.usedSpaceM2
                                        : ""
                                }}&#13217;, Total =
                                {{
                                    greenhouseDepartmentSection
                                        ? greenhouseDepartmentSection.spaceM2
                                        : ""
                                }}&#13217;</strong
                            >
                            <v-spacer />
                        </v-progress-linear>
                    </v-card-actions>
                </v-card>
            </template>
        </v-dialog>
    </v-row>
</template>

<script>
import gql from "graphql-tag";
import helper from "@/utils/helper.js";
import moment from "moment";
import GrowthTaskCard from "@/components/growth/GrowthTaskCard.vue";

export default {
    name: "greenhouse-department-section-tasks-dialog",
    props: ["dialog", "selectedSectionNodeId"],
    components: {
        GrowthTaskCard
    },

    apollo: {
        greenhouseDepartmentSection: {
            query: gql`
                query greenhouseDepartmentSection($id: ID!) {
                    greenhouseDepartmentSection(id: $id) {
                        id
                        isActive
                        name
                        layoutX
                        layoutY
                        width
                        height
                        spaceM2
                        usedSpaceM2
                        usedRate
                        greenhouseDepartment {
                            id
                            name
                            layoutX
                            layoutY
                            width
                            height
                            totalSpaceM2
                            totalUsedSpaceM2
                            totalUsedRate
                            greenhouse {
                                id
                                name
                            }
                        }
                        growthTaskPhaseSet(
                            isCurrentPhase: true
                            growthTask_TotalInventory_Gt: 0
                            orderBy: "phaseNo"
                        ) {
                            edges {
                                node {
                                    id
                                    phaseNo
                                    startDate
                                    endDate
                                    numDays
                                    numPlantsPerM2
                                    spaceM2
                                    isSalesPhase
                                    isCurrentPhase
                                    remindedDate
                                    confirmedDate
                                    growthTask {
                                        id
                                        rawId
                                        note
                                        numPhases
                                        totalGrowthDays
                                        growthStartDate
                                        growthEndDate
                                        maxSalesDays
                                        salesStartDate
                                        salesEndDate
                                        lockedDate
                                        lockedComment
                                        lockedForCustomer {
                                            id
                                            name
                                        }
                                        closedDate
                                        closedReason
                                        plant {
                                            id
                                            name
                                            plantSpecies {
                                                id
                                                name
                                            }
                                            plantTagSet {
                                                edges {
                                                    node {
                                                        id
                                                        tag {
                                                            id
                                                            tag
                                                            orderId
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        color {
                                            id
                                            color
                                        }
                                        potSize {
                                            id
                                            potSizeCm
                                        }
                                        environment {
                                            id
                                            environment
                                        }
                                        tag {
                                            id
                                            tag
                                        }
                                        plantGrowthTemplate {
                                            id
                                            name
                                        }
                                        supplier {
                                            id
                                            name
                                        }
                                        supplierOrderNo
                                        note
                                        totalQuantity
                                        totalInventory
                                        growthTaskPhaseSet {
                                            edges {
                                                node {
                                                    id
                                                    phaseNo
                                                    startDate
                                                    endDate
                                                    numDays
                                                    numPlantsPerM2
                                                    spaceM2
                                                    isSalesPhase
                                                    isCurrentPhase
                                                    remindedDate
                                                    confirmedDate
                                                    greenhouseDepartmentSection {
                                                        id
                                                        name
                                                        greenhouseDepartment {
                                                            id
                                                            name
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        createdAt
                                    }
                                }
                            }
                        }
                    }
                }
            `,
            variables() {
                return {
                    id: this.selectedSectionNodeId
                    // orderStatus_In: this.orderStatusFilter
                };
            },
            // Additional options here
            fetchPolicy: "cache-and-network",
            update: data => data.greenhouseDepartmentSection,
            skip() {
                return !this.selectedSectionNodeId;
            },
            pollInterval: 60000 // ms
        }
    },

    data: function() {
        return {
            // isLoadingSection: false,
            greenhouseDepartmentSection: null,
            search: "",
            // plannedTasks: [],
            // growingTasks: [],
            // salesTasks: [],
            rules: {
                required: v => !helper.isEmpty(v) || "This field is required",
                listRequired: v =>
                    (v || "").length >= 1 || `This field is required`,
                minLength: len => v =>
                    (v || "").length >= len || `Require at least ${len}`,
                maxLength: len => v => (v || "").length <= len || "Too long",
                maxNumber: num => v => (v || 1) <= num || "Out of range"
            }
        };
    },
    computed: {
        // customers() {
        //     return this.$store.state.customers.customers;
        // },
        todayStr() {
            var _now = new Date();

            return moment(_now).format("YYYY-MM-DD");
        },
        plannedTasks() {
            let today = new Date();
            today.setHours(0, 0, 0, 0); // remove time

            var _tasks = [];

            if (this.greenhouseDepartmentSection !== null) {
                _tasks = this.greenhouseDepartmentSection.growthTaskPhaseSet.edges
                    .filter(
                        item =>
                            (!item.node.isSalesPhase &&
                                item.node.phaseNo === 1 &&
                                item.node.confirmedDate === null) ||
                            item.node.growthTask.growthStartDate > this.todayStr
                    )
                    .filter(
                        item =>
                            item.node.growthTask.plant.name
                                .toLowerCase()
                                .includes((this.search || "").toLowerCase()) ||
                            moment(item.node.growthTask.createdAt)
                                .format("YYYYMMDDHHmmSS")
                                .includes(
                                    (this.search || ".").replace(/-/g, "")
                                )
                    )
                    .map(item => {
                        return {
                            ...item.node.growthTask,
                            daysToNextPhase: moment(item.node.startDate).diff(
                                today,
                                "days"
                            )
                        };
                    })
                    .sort((a, b) => {
                        // if days to next phase is same, then sort by plant name
                        if (a.daysToNextPhase === b.daysToNextPhase) {
                            return a.plant.name.toLowerCase() ==
                                b.plant.name.toLowerCase()
                                ? 0
                                : a.plant.name.toLowerCase() >
                                  b.plant.name.toLowerCase()
                                ? 1
                                : -1;
                        }

                        return a.daysToNextPhase - b.daysToNextPhase;
                    });
            }

            return _tasks;
        },
        growingTasks() {
            let today = new Date();
            today.setHours(0, 0, 0, 0); // remove time

            var _tasks = [];

            //
            if (this.greenhouseDepartmentSection !== null) {
                _tasks = this.greenhouseDepartmentSection.growthTaskPhaseSet.edges
                    .filter(
                        item =>
                            !item.node.isSalesPhase &&
                            item.node.confirmedDate !== null &&
                            item.node.growthTask.growthStartDate <=
                                this.todayStr
                    )
                    .filter(
                        item =>
                            item.node.growthTask.plant.name
                                .toLowerCase()
                                .includes((this.search || "").toLowerCase()) ||
                            moment(item.node.growthTask.createdAt)
                                .format("YYYYMMDDHHmmSS")
                                .includes(
                                    (this.search || ".").replace(/-/g, "")
                                )
                    )
                    .map(item => {
                        return {
                            ...item.node.growthTask,
                            daysToNextPhase: moment(item.node.endDate).diff(
                                today,
                                "days"
                            )
                        };
                    })
                    .sort((a, b) => {
                        // if days to next phase is same, then sort by plant name
                        if (a.daysToNextPhase === b.daysToNextPhase) {
                            return a.plant.name.toLowerCase() ==
                                b.plant.name.toLowerCase()
                                ? 0
                                : a.plant.name.toLowerCase() >
                                  b.plant.name.toLowerCase()
                                ? 1
                                : -1;
                        }

                        return a.daysToNextPhase - b.daysToNextPhase;
                    });
            }

            return _tasks;
        },
        salesTasks() {
            let today = new Date();
            today.setHours(0, 0, 0, 0); // remove time

            var _tasks = [];

            if (this.greenhouseDepartmentSection !== null) {
                _tasks = this.greenhouseDepartmentSection.growthTaskPhaseSet.edges
                    .filter(item => item.node.isSalesPhase)
                    .filter(
                        item =>
                            item.node.growthTask.plant.name
                                .toLowerCase()
                                .includes((this.search || "").toLowerCase()) ||
                            moment(item.node.growthTask.createdAt)
                                .format("YYYYMMDDHHmmSS")
                                .includes(
                                    (this.search || ".").replace(/-/g, "")
                                )
                    )
                    .map(item => {
                        return {
                            ...item.node.growthTask,
                            daysToNextPhase: moment(item.node.endDate).diff(
                                today,
                                "days"
                            )
                        };
                    })
                    .sort((a, b) => {
                        // if days to next phase is same, then sort by plant name
                        if (a.daysToNextPhase === b.daysToNextPhase) {
                            return a.plant.name.toLowerCase() ==
                                b.plant.name.toLowerCase()
                                ? 0
                                : a.plant.name.toLowerCase() >
                                  b.plant.name.toLowerCase()
                                ? 1
                                : -1;
                        }

                        return a.daysToNextPhase - b.daysToNextPhase;
                    });
            }

            return _tasks;
        },

        numPlantsInPlannedTasks() {
            return this.plannedTasks.reduce((a, b) => a + b.totalInventory, 0);
        },
        numPlantsInGrowingTasks() {
            return this.growingTasks.reduce((a, b) => a + b.totalInventory, 0);
        },
        numPlantsInSalingTasks() {
            return this.salesTasks.reduce((a, b) => a + b.totalInventory, 0);
        }
    },
    watch: {
        // // reset form when dialog open or close
        dialog(val) {
            if (val) {
                // reset form
                this.$apollo.queries.greenhouseDepartmentSection.refresh();
            }
        }
        // selectedSectionNodeId(val) {
        //     if (val !== null) {
        //         this.fetchSingleSection(val);
        //     }
        // }
    },
    methods: {
        // fetchSingleSection(sectionNodeId) {
        //     this.isLoadingSection = "white";
        //     this.$store
        //         .dispatch(
        //             "greenhouseDepartmentSections/fetchSingleGreenhouseDepartmentSection",
        //             sectionNodeId
        //         )
        //         .then(response => {
        //             // let today = new Date();
        //             // today.setHours(0, 0, 0, 0); // remove time

        //             this.greenhouseDepartmentSection = JSON.parse(
        //                 JSON.stringify(response)
        //             );

        //             // // fetch all sections
        //             // this.fetchAllSections();
        //             // this.fetchSuppliers();
        //         })
        //         .catch(error => {
        //             console.log(error);
        //         })
        //         .finally(() => (this.isLoadingSection = false));
        // },

        // fetchAllSections() {
        //     // fetch section
        //     this.isLoadingGreenhouseDepartmentSections = true;

        //     this.$store
        //         .dispatch(
        //             "greenhouseDepartmentSections/fetchGreenhouseDepartmentSections"
        //         )
        //         .then(() => {
        //             // console.log(this.greenhouseDepartmentSections);
        //         })
        //         .catch(error => {
        //             /*handle errors*/
        //             console.log(error);
        //         })
        //         .finally(
        //             () => (this.isLoadingGreenhouseDepartmentSections = false)
        //         );
        // },

        // fetchSuppliers() {
        //     // fetch suppliers
        //     this.$store
        //         .dispatch("suppliers/fetchSuppliers")
        //         .then(() => {})
        //         .catch(error => {
        //             /*handle errors*/
        //             console.log(error);
        //         })
        //         .finally();
        // },

        growthTaskPhasesUpdated() {
            // this.fetchSingleSection(this.greenhouseDepartmentSection.id);
            this.$apollo.queries.greenhouseDepartmentSection.refresh();
        },

        growthTaskPhaseConfirmed() {
            // this.fetchSingleSection(this.greenhouseDepartmentSection.id);
            this.$apollo.queries.greenhouseDepartmentSection.refresh();
        },

        growthTaskInventoryUpdated() {
            // this.fetchSingleSection(this.greenhouseDepartmentSection.id);
            this.$apollo.queries.greenhouseDepartmentSection.refresh();
        },

        onTaskLocked() {
            // this.fetchSingleSection(this.greenhouseDepartmentSection.id);
            this.$apollo.queries.greenhouseDepartmentSection.refresh();
        },

        onTaskUnlocked() {
            // this.fetchSingleSection(this.greenhouseDepartmentSection.id);
            this.$apollo.queries.greenhouseDepartmentSection.refresh();
        },

        onTaskSplited() {
            // this.fetchSingleSection(this.greenhouseDepartmentSection.id);
            this.$apollo.queries.greenhouseDepartmentSection.refresh();
        },

        onTaskSupplierUpdated() {
            // this.fetchSingleSection(this.greenhouseDepartmentSection.id);
            this.$apollo.queries.greenhouseDepartmentSection.refresh();
        },

        onTaskDeleted() {
            // this.fetchSingleSection(this.greenhouseDepartmentSection.id);
            this.$apollo.queries.greenhouseDepartmentSection.refresh();
        },

        close() {
            this.$emit("update:dialog", false);
            this.search = "";
            setTimeout(() => {
                this.greenhouseDepartmentSection = null;
            }, 1000);
        }
    }
};
</script>